export default ".fixe-end {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}"